import { createContext, useContext } from "react";

export interface IntegrationRowActionsContextValue {
    organizationId: string;
    /**
     * Connections emailed during this page session. The server's 24h cooldown
     * lives only in Redis and is exposed on no schema, so a second attempt can
     * only be pre-empted for as long as the page is open.
     */
    remindedConnectionIds: ReadonlySet<string>;
    markConnectionReminded: (connectionId: string) => void;
    /**
     * Called after an account is removed. The row's group header carries a count
     * and the group can empty out entirely — neither of which the invalidation
     * alone fixes, and neither of which the cell can see.
     */
    onAccountRemoved: () => void;
}

export const IntegrationRowActionsContext =
    createContext<IntegrationRowActionsContextValue | null>(null);

export function useIntegrationRowActions() {
    const context = useContext(IntegrationRowActionsContext);
    if (!context) {
        throw new Error(
            "useIntegrationRowActions must be used within an IntegrationRowActionsContext.Provider",
        );
    }
    return context;
}
